import React from 'react';
import { connect } from 'react-redux';
import { initApp } from './actions/environmentActions';
import Modal from './Components/Modal';
import Spinner from './Components/Spinner';
import { changeTab, setPageName } from './actions/environmentActions';
// import smoothscroll from 'smoothscroll-polyfill';
import { hashHistory   } from 'react-router' //, hashHistory 


class App extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            unlisten : null,
        }
    }


    componentWillMount() {
        if(window.firebaseAnalytics){
            this.unlisten = hashHistory.listen((location, action) => {
                // console.log(location);
                window.firebaseAnalytics.logEvent('screen_view',location).then();
            })
        }
        else {
            // console.log("No Firebase Function")
        }
    }
    

    componentWillUnmount() {
        if(typeof this.unlisten === "function"){
            this.unlisten();
        }
    }
 

    componentDidMount(){

        this.props.init();
        this.props.updateTab();
        window.onMedefyAppResume = this.onMedefyAppResume;
    }

    onMedefyAppResume =()=>{
        this.props.init();
    }

    render() {

        const { isAuthenticated, isFetching } = this.props;

        return (
            <div>
                <div >
                    <div  className="bg-app">
                        {isFetching && (
                            <Spinner />
                        )}
                        
                        {!isFetching && isAuthenticated && (
                            <div className="app-children">
                                {this.props.children}
                            </div>
                        )}
                          {/* <TabStrip activeTab={1} /> */}
                    </div>
                </div>
                
                <Modal />
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        init: () => {
            dispatch(initApp(true));
        }, 
        updateTab: () => {
            dispatch(changeTab("0"))
        }
    }
}

function mapStateToProps(state) {

    const { isAuthenticated } = state.thisApp.auth;
    const { isFetching } = state.thisApp.environment;
   
    return {
        isAuthenticated,
        isFetching
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);




// WEBPACK FOOTER //
// ./src/App.js